import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, RouterStateSnapshot } from '@angular/router';
import { LicenseService } from '../services/license.service';
import { ArtiEnvironment, ENVIRONMENT } from '@environments/model';

@Injectable({
  providedIn: 'root',
})
export class ArtifactRepoConsentGuard implements CanActivate {
  constructor(
    private licenseService: LicenseService,
    @Inject(ENVIRONMENT) private environment: ArtiEnvironment,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    if (!this.environment.consentManagement) {
      return true;
    }

    const serviceToken = route.data['serviceToken'];
    if (!serviceToken) {
      throw new Error('Invalid configuration for consent guard. Service token is missing.');
    }

    const notAcceptedConsentUrl = this.licenseService.getNotAcceptedConsentUrl(serviceToken);
    if (notAcceptedConsentUrl === undefined) {
      return true;
    }

    const redirectUrl = `${notAcceptedConsentUrl}?redirect_to=${document.location.origin}${state.url}`;
    document.location.href = redirectUrl;
    return false;
  }
}
